import { StreamSimulator, sperator } from "imagica-corekit/dist/base/util/StreamSimulator";
import { isEmpty } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";

export type UseStreamTextProps = {
  content?: string;
  disabled?: boolean;
  isStreamStopped?: boolean;
  onStreamingStateChanged?: (streaming: boolean) => void;
  onStreamingContentChanged?: (content: string) => void;
  onStreamingContentStopped?: (content?: string) => void;
};

function getDefaultState(props?: UseStreamTextProps) {
  return {
    streamContent: props?.disabled ? props?.content : "",
    streaming: false,
    streamList: [] as string[],
  };
}

export function useStreamText(props?: UseStreamTextProps) {
  const {
    content = "",
    disabled,
    onStreamingStateChanged,
    onStreamingContentChanged,
    onStreamingContentStopped,
  } = props || {};
  const streamSimulator = useRef(new StreamSimulator({ delay: 150 }));

  const [innerState, setInnerState] = useState(getDefaultState(props));

  const stop = useCallback(
    (isManual: boolean) => {
      streamSimulator.current?.stop();
      setInnerState({ streamContent: content, streaming: false, streamList: innerState.streamList });
      if (isManual) {
        /// 手动停止动画，通知外部整个动画执行完成，并返回当前输出内容
        onStreamingContentStopped?.(innerState.streamList.join(sperator));
      }
    },
    [innerState.streamList]
  );

  const refresh = useCallback(() => {
    streamSimulator.current?.stop();
    if (content && !disabled) {
      setInnerState({ ...getDefaultState(props), streaming: true });

      streamSimulator.current.reset({ content }).startByWord(({ status, streamList }) => {
        setInnerState({ streamContent: content, streaming: status === "pending", streamList });
        onStreamingContentChanged?.(innerState.streamList.join(sperator));
      });
    }
  }, [disabled, content]);

  useEffect(() => {
    onStreamingStateChanged?.(innerState.streaming);
    if (!innerState.streaming && !isEmpty(innerState.streamList)) {
      /// 通知外部整个动画执行完成
      onStreamingContentStopped?.();
    }
  }, [innerState.streaming]);

  useEffect(() => {
    refresh();
    return () => {
      streamSimulator.current?.stop();
    };
  }, [disabled, content]);

  return {
    ...innerState,
    refresh,
    stop,
  };
}
